import Page from '../../class/Page';
import Accordion from '../../components/accordion';

window.pageCurrent = class extends Page {
    init() {
        super.init();

        this.initAllComponents('.accordion-item', Accordion);
    }
};
